<figure class="sh-contained-media">
    <img [src]="blobUrl" class="sh-contained-media__media" alt="Thumbnail" />
</figure>
